<template>
    <div class="quiz-page">
        <div class="quiz-page-header">
            <q-btn square unelevated icon="arrow_back" label="Retour à l'exposition" no-caps class="quiz-return-btn"
                @click="goBack" />
        </div>
        <QuizPlayer :quizId="$route.params.id" />
    </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import QuizPlayer from '../components/QuizPlayer.vue';

export default {
    name: 'QuizView',
    components: { QuizPlayer },
    setup() {
        const router = useRouter();
        const route = useRoute();

        // Le quiz pleine page s'ouvre dans un NOUVEL onglet (template_6), sans
        // historique : router.back() n'avait rien à remonter et l'ancien
        // repli, router.push('/'), menait à la page de connexion, alors que
        // l'exposition restait ouverte dans l'onglet d'origine.
        const goBack = () => {
            // 1. Onglet ouvert par l'exposition : on le referme, le visiteur
            //    retrouve l'exposition telle qu'il l'a laissée.
            if (window.opener && !window.opener.closed) {
                window.close();
                return;
            }
            // 2. Lien ouvert autrement : retour à l'exposition d'origine.
            //    Seul un chemin interne est accepté.
            const retour = route.query.retour;
            if (typeof retour === 'string' && retour.startsWith('/expo/')) {
                router.push(retour);
                return;
            }
            // 3. Arrivée dans l'application par un autre chemin.
            if (window.history.length > 1) router.back();
            else router.push('/');
        };
        return { goBack };
    },
};
</script>

<style scoped>
.quiz-page {
    min-height: 100vh;
    background: rgb(217, 217, 217);
    display: flex;
}

.quiz-page-header {
    position: fixed;
    top: 16px;
    left: 16px;
    z-index: 10;
}

.quiz-return-btn {
    background: rgba(255, 255, 255, 0.95);
    color: #222;
    min-height: 48px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
}
</style>
